'use strict';

var tooltip = {};

exports.__exports = tooltip;
//# sourceMappingURL=tooltip.cjs.map
